import { getApiUrl } from '../config/api';

export interface User {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
}

export interface AuthResponse {
  success: boolean;
  message: string;
  data?: User;
}

export interface LoginData {
  email: string;
  password: string;
}

export interface RegisterData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

class AuthService {
  private async makeRequest(endpoint: string, data: any): Promise<AuthResponse> {
    try {
      const response = await fetch(getApiUrl(endpoint), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'An error occurred');
      }

      return result;
    } catch (error: any) {
      throw new Error(error.message || 'Network error occurred');
    }
  }

  async login(loginData: LoginData): Promise<AuthResponse> {
    return this.makeRequest('login.php', loginData);
  }

  async signup(registerData: RegisterData): Promise<AuthResponse> {
    return this.makeRequest('register.php', registerData);
  }

  setUser(user: User): void {
    localStorage.setItem('user', JSON.stringify(user));
  }

  getUser(): User | null {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }

  logout(): void {
    localStorage.removeItem('user');
  }

  isAuthenticated(): boolean {
    return this.getUser() !== null;
  }
}

export default new AuthService();
